export default __webpack_public_path__ + "static/media/logo-ax.7103c87d.png";